<header class="homepage-header lg-header">
  <section class="header-left d-flex justify-content-between width-66">
    <img class="header-logo" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">

    <div class="header-menu-container">
      @for (menuItem of menuItems; track menuItem) {
        <div class="header-menu" [class]="currentRoute == menuItem.routerLink ? 'active' : ''">
          <span [routerLink]="menuItem.routerLink">{{ menuItem.title  | translate}}</span>
        </div>
      }
    </div>
        <app-search></app-search>
  </section>

  <section class="header-right width-26"
    [ngClass]="currentUser ? 'justify-content-end' : 'justify-content-between'"
  >

    @if (showRightButtons && !hasCurrentUser) {
      <div class="header-right-actions">
        <a class="text-button short-button mr-10px" routerLink="/login">{{'home-page-content.login' | translate}}</a>
        <a class="filled-button short-button" routerLink="/sign-up">{{'home-page-content.create_card' | translate}}</a>
      </div>
    }

    <div class="header-right-icons justify-content-between gap-10px width-70px">
      @if (hasCurrentUser) {
        <div class="user-info-wrapper-desktop">
          <div class="user-info-wrapper header-links">
            <a class="user-info" [matMenuTriggerFor]="userInfo" [matMenuTriggerRestoreFocus]="false">
              <img
                [src]="profileImage ?? 'assets/svg/defaultUserIcon.svg'"
                class="img-style"
                alt="">
            </a>
          </div>
        </div>
      }
      <div class="positioned-inline">
        <svg class="shopping-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [routerLink]="'/cart'">
          <mask id="mask0_1049_2015" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1049_2015)">
            <path
              d="M7 22C6.45 22 5.97917 21.8042 5.5875 21.4125C5.19583 21.0208 5 20.55 5 20C5 19.45 5.19583 18.9792 5.5875 18.5875C5.97917 18.1958 6.45 18 7 18C7.55 18 8.02083 18.1958 8.4125 18.5875C8.80417 18.9792 9 19.45 9 20C9 20.55 8.80417 21.0208 8.4125 21.4125C8.02083 21.8042 7.55 22 7 22ZM17 22C16.45 22 15.9792 21.8042 15.5875 21.4125C15.1958 21.0208 15 20.55 15 20C15 19.45 15.1958 18.9792 15.5875 18.5875C15.9792 18.1958 16.45 18 17 18C17.55 18 18.0208 18.1958 18.4125 18.5875C18.8042 18.9792 19 19.45 19 20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22ZM6.15 6L8.55 11H15.55L18.3 6H6.15ZM5.2 4H19.95C20.3333 4 20.625 4.17083 20.825 4.5125C21.025 4.85417 21.0333 5.2 20.85 5.55L17.3 11.95C17.1167 12.2833 16.8708 12.5417 16.5625 12.725C16.2542 12.9083 15.9167 13 15.55 13H8.1L7 15H19V17H7C6.25 17 5.68333 16.6708 5.3 16.0125C4.91667 15.3542 4.9 14.7 5.25 14.05L6.6 11.6L3 4H1V2H4.25L5.2 4Z"
              fill="#12314F"
            />
          </g>
        </svg>
        @if (total > 0) {
          <span class="cart-badge">{{ total }}</span>
        }
      </div>

      <span id="language" [matMenuTriggerFor]="languageChange">{{ lang | uppercase }}</span>

      <mat-menu #languageChange='matMenu' xPosition="before" yPosition="below">
        <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.HY)">{{Language.HY | uppercase}}</p>
        <hr class="lang-mat-menu-hr">
        <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.EN)">{{Language.EN | uppercase}}</p>
        <hr class="lang-mat-menu-hr">
        <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.RU)">{{Language.RU | uppercase}}</p>
      </mat-menu>
    </div>
  </section>
</header>

<header class="mb-header">
  <section class="header-top">
    <div class="header-left col-4">
      @if (isHomepageHeader) {
        <img class="header-logo" src="assets/svg/logo.svg" alt="header logo">
      } @else {
        <div class="d-flex align-items-center flex-direction-row justify-content-between">
          <mat-icon class="header-page-arrow-mb cursor-pointer" (click)="goBack()">arrow_back</mat-icon>
          <span class="header-page-name-mb">{{pageName}}</span>
        </div>
      }
    </div>

    <div class="header-right justify-content-end col-8">
      <div class="header-right-icons flex-direction-row gap-10px">
        @if (hasCurrentUser) {
          <div class="user-info-wrapper-desktop">
            <div class="user-info-wrapper header-links">
              <a class="user-info" [matMenuTriggerFor]="userInfo" [matMenuTriggerRestoreFocus]="false">
                <img
                  [src]="profileImage ?? 'assets/svg/defaultUserIcon.svg'"
                  class="img-style"
                  alt="">
              </a>
            </div>
          </div>
        }
        <div class="positioned-inline">
          <svg class="shopping-icon" width="24" height="24" viewBox="0 0 24 24" fill="#6B6C77" xmlns="http://www.w3.org/2000/svg" [routerLink]="'/cart'">
            <mask id="mask0_1049_2015" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_1049_2015)">
              <path d="M7 22C6.45 22 5.97917 21.8042 5.5875 21.4125C5.19583 21.0208 5 20.55 5 20C5 19.45 5.19583 18.9792 5.5875 18.5875C5.97917 18.1958 6.45 18 7 18C7.55 18 8.02083 18.1958 8.4125 18.5875C8.80417 18.9792 9 19.45 9 20C9 20.55 8.80417 21.0208 8.4125 21.4125C8.02083 21.8042 7.55 22 7 22ZM17 22C16.45 22 15.9792 21.8042 15.5875 21.4125C15.1958 21.0208 15 20.55 15 20C15 19.45 15.1958 18.9792 15.5875 18.5875C15.9792 18.1958 16.45 18 17 18C17.55 18 18.0208 18.1958 18.4125 18.5875C18.8042 18.9792 19 19.45 19 20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22ZM6.15 6L8.55 11H15.55L18.3 6H6.15ZM5.2 4H19.95C20.3333 4 20.625 4.17083 20.825 4.5125C21.025 4.85417 21.0333 5.2 20.85 5.55L17.3 11.95C17.1167 12.2833 16.8708 12.5417 16.5625 12.725C16.2542 12.9083 15.9167 13 15.55 13H8.1L7 15H19V17H7C6.25 17 5.68333 16.6708 5.3 16.0125C4.91667 15.3542 4.9 14.7 5.25 14.05L6.6 11.6L3 4H1V2H4.25L5.2 4Z"/>
            </g>
          </svg>
          @if (total > 0) {
            <span class="cart-badge">{{ total }}</span>
          }
        </div>

        <svg class="cursor-pointer" (click)="toggleMenu()" width="18" height="12" viewBox="0 0 18 12" fill="#6B6C77" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2V0H18V2H0ZM0 7H18V5H0V7ZM0 12H18V10H0V12Z" fill="#6B6C77"/>
        </svg>
      </div>
    </div>
  </section>

  <section class="header-bottom">
    <div class="header-search">
      <app-search></app-search>
    </div>
  </section>
</header>

<app-hamburger-menu [isOpened]="isMenuOpened" (menuClosed)="menuClosed()"></app-hamburger-menu>

<mat-menu #userInfo class="user-info-mat-menu">
  @if (hasCurrentUser) {
    <div class="user-info-top" (click)="$event.stopPropagation()">
      <mat-icon class="user-info-edit-icon" (click)="showProfileEdit(); userInfo.closed.emit(); $event.stopPropagation();">
        edit_outline
      </mat-icon>

      <ul class="user-info-column">
        <li>
          <mat-icon class="mr-14px user-info-def-icon">person_outline</mat-icon>
          {{ currentUser?.name }} {{ currentUser?.surname }}
        </li>
        <li>
          <mat-icon class="mr-14px user-info-def-icon">mail_outline</mat-icon>
          {{ currentUser?.email ? currentUser?.email : 'Unknown' }}
        </li>
        <li>
          <mat-icon class="mr-14px user-info-def-icon">phone_enabled_outline</mat-icon>
          {{ currentUser?.phoneNumber ? currentUser?.phoneNumber : 'Unknown' }}
        </li>
      </ul>
    </div>
    <hr class="user-info-hr" (click)="$event.stopPropagation()">
    <div class="user-info-bottom" (click)="redirectToCards()">
      <span>{{'home-page-content.go_to_profile' | translate}}</span>
      <mat-icon class="user-info-logout-icon">person_outline</mat-icon>
    </div>
    <div class="user-info-bottom" (click)="logout(); userInfo.closed.emit()">
      <span>{{'home-page-content.sign_out' | translate}}</span>
      <mat-icon class="user-info-logout-icon">logout</mat-icon>
    </div>
  }
</mat-menu>
